export default __webpack_public_path__ + "static/media/more.2db5cd18.svg";